// import React, { useEffect, useState } from 'react'
// import { BrowserRouter, Route, Routes } from 'react-router-dom'
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './Assets/Css/home.css'
// import './App.css';
// import ScrollToTop from './Webpages/ScrollToTop'

// import WebHeader from './Components/WebHeader'
// import WebFooter from './Components/WebFooter'
// import HomePage from './Webpages/HomePage'
// import Contact from './Webpages/Contact';
// // import logoarrow from '../src/Assets/Image/trident-logo.jpg'
// import AboutUs from './Webpages/AboutUs';
// import Services from './Webpages/Services';
// import AgriFacility from './Webpages/AgriFacility';
// import ITDigitalServices from './Webpages/ITDigitalServices';
// import IntroStrategySessions from './Webpages/IntroStrategySessions';

// import { BiUpArrowAlt } from "react-icons/bi";
// import { FaWhatsapp } from 'react-icons/fa';
// import Products from './Webpages/Products';
// import AdminLogin from './Components/AdminLogin';
// import Dashboard from './Components/Dashboard';

// import Gallery from './Components/Gallery';




// // Pages
// const App = () => {

//   const [showScroll, setShowScroll] = useState(false);

//   useEffect(() => {
//     const checkScroll = () => {
//       if (window.scrollY > window.innerHeight / 2) {
//         setShowScroll(true);
//       } else {
//         setShowScroll(false);
//       }
//     };

//     window.addEventListener("scroll", checkScroll);
//     return () => window.removeEventListener("scroll", checkScroll);
//   }, []);

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   return (
//     <BrowserRouter>

//       <WebHeader />
//       <div>
//         <ScrollToTop />
//       <Routes>
//   <Route path="*" name="HomePage" element={<HomePage />} />
//   <Route path="/" name="HomePage" element={<HomePage />} />
//   <Route path="/admin" name="Admin" element={<AdminLogin />} />
//   <Route path="/dashboard" element={ <Dashboard/>} />
//   <Route path="/gallerydata" element={<Gallery/>}/>
//   <Route path="/contact" name="Contact" element={<Contact />} />
//   <Route path="/aboutus" name="About" element={<AboutUs />} />
//   <Route path="/services" name="Services" element={<Services />} />
//   <Route path="/products" name="Products" element={<Products />} />
//   <Route path="/gallery" name="Gallery" element={<IntroStrategySessions />} />


// <Route path="/facilities/agri" name="AgriFacility" element={<AgriFacility />} />
// <Route path="/facilities/it-digital" name="ITDigital" element={<ITDigitalServices />} />
// </Routes>

//          <a
//           href="https://wa.me/7772036678"
//           className="whatsapp-icon"
//           target="_blank"
//           rel="noopener noreferrer"
//           title="Chat with us!"
//         >
//           <FaWhatsapp />
//         </a> 


//         {showScroll && (
//           <button className="scroll-to-top show" onClick={scrollToTop}>
//               <BiUpArrowAlt  className='scrollbtn' title="Scroll to Top" />
//           </button>
//         )}
//       </div>
//       <WebFooter />
//     </BrowserRouter>
//   )
// }

// export default App












import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Assets/Css/home.css';
import './App.css';
import ScrollToTop from './Webpages/ScrollToTop';

import WebHeader from './Components/WebHeader';
import WebFooter from './Components/WebFooter';
import HomePage from './Webpages/HomePage';
import Contact from './Webpages/Contact';
import AboutUs from './Webpages/AboutUs';
import Services from './Webpages/Services';
import AgriFacility from './Webpages/AgriFacility';
import ITDigitalServices from './Webpages/ITDigitalServices';
import IntroStrategySessions from './Webpages/IntroStrategySessions';

import { BiUpArrowAlt } from 'react-icons/bi';
import { FaWhatsapp } from 'react-icons/fa';
import Products from './Webpages/Products';
import AdminLogin from './Components/AdminLogin';
import Dashboard from './Components/Dashboard';

import Gallery from './Components/Gallery';
import ProtectedRoute from './Components/ProtectedRoute';

const AppContent = () => {
  const [showScroll, setShowScroll] = useState(false);
  const location = useLocation();

 const hideHeaderFooter = ['/admin', '/dashboard', '/gallerydata'].includes(location.pathname);


  useEffect(() => {
    const checkScroll = () => {
      setShowScroll(window.scrollY > window.innerHeight / 2);
    };

    window.addEventListener('scroll', checkScroll);
    return () => window.removeEventListener('scroll', checkScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {!hideHeaderFooter && <WebHeader />}
      <ScrollToTop />

      <Routes>
        <Route path="*" element={<HomePage />} />
        <Route path="/" element={<HomePage />} />
       
        <Route path="/contact" element={<Contact />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/products" element={<Products />} />
        <Route path="/gallery" element={<IntroStrategySessions />} />
        <Route path="/facilities/agri" element={<AgriFacility />} />
        <Route path="/facilities/it-digital" element={<ITDigitalServices />} />

         <Route path="/admin" element={<AdminLogin />} />
          
          {/* <Route path="/dashboard" element={ <Dashboard/>  } />
           <Route path="/gallerydata" element={  <Gallery/> } /> */}

             {/* ✅ Protected Routes */}
  <Route
    path="/dashboard"
    element={
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    }
  />
  <Route
    path="/gallerydata"
    element={
      <ProtectedRoute>
        <Gallery />
      </ProtectedRoute>
    }
  />
      
      </Routes>

      {!hideHeaderFooter && (
        <>
          <a
            href="https://wa.me/7772036678"
            className="whatsapp-icon"
            target="_blank"
            rel="noopener noreferrer"
            title="Chat with us!"
          >
            <FaWhatsapp />
          </a>

          {showScroll && (
            <button className="scroll-to-top show" onClick={scrollToTop}>
              <BiUpArrowAlt className="scrollbtn" title="Scroll to Top" />
            </button>
          )}
        </>
      )}
     
      {!hideHeaderFooter && <WebFooter />}
    
    </>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
};

export default App;

